/** Triggers a browser download from an already downloadable URL, e.g. a pre-signed S3 link. */
export const downloadFromUrl = (url: string, fileName: string): void => {
	const anchor = document.createElement("a")
	anchor.href = url
	anchor.download = fileName
	anchor.click()
}
